<template>
    <span class="ai-analyze d-inline-block">
        <button type="button" class="btn btn-sm btn-outline-info"
            :disabled="loading" @click="analyze"
            :title="$t('Get an AI observation on this image')">
            <app-icon name="activity" /> {{ loading ? $t('Analysing…') : $t('AI analysis') }}
        </button>

        <div v-if="analysis !== null" class="ai-analyze-panel card mt-2 mb-2">
            <div class="card-body p-2">
                <small class="text-muted d-block mb-1">
                    {{ $t('AI observation') }} — {{ $t('assistive only, verify clinically') }}:
                </small>
                <div class="ai-analysis mb-2">{{ analysis }}</div>
                <button type="button" class="btn btn-sm btn-primary mr-2" @click="insert">{{ $t('Insert into comment') }}</button>
                <button type="button" class="btn btn-sm btn-outline-secondary mr-2" @click="copy">{{ $t('Copy') }}</button>
                <button type="button" class="btn btn-sm btn-link text-muted" @click="dismiss">{{ $t('Dismiss') }}</button>
            </div>
        </div>
    </span>
</template>

<script>
import { axiosPost } from "../../../../../common/Helper/AxiosHelper";
import { AI_ANALYZE_IMAGE } from "../../../../Config/ApiUrl-CP";

export default {
    name: "ai-image-analysis-button",
    props: {
        assessmentId: { required: true },
        slot: { type: Number, default: 1 },
    },
    data() {
        return { loading: false, analysis: null };
    },
    methods: {
        analyze() {
            if (!this.assessmentId) {
                this.$toastr.e(this.$t("Save the assessment first, then run the analysis."));
                return;
            }
            this.loading = true;
            this.analysis = null;
            axiosPost(AI_ANALYZE_IMAGE, { assessment_id: this.assessmentId, slot: this.slot })
                .then((res) => {
                    this.analysis = (res.data && res.data.analysis) || "";
                })
                .catch((e) => {
                    const msg = (e.response && e.response.data && e.response.data.message)
                        || this.$t("AI request failed.");
                    this.$toastr.e(msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        insert() {
            this.$emit("insert", this.analysis);
            this.analysis = null;
        },
        copy() {
            try {
                navigator.clipboard.writeText(this.analysis || "");
                this.$toastr.s(this.$t("Copied."));
            } catch (e) { /* clipboard may be unavailable */ }
        },
        dismiss() {
            this.analysis = null;
        },
    },
};
</script>

<style scoped>
.ai-analysis {
    white-space: pre-line;
    font-size: 13px;
    background: #f6fbff;
    border: 1px solid #cfe8f7;
    border-radius: 4px;
    padding: 8px;
}
.ai-analyze-panel { border-color: #cfe8f7; }
</style>
